<template>
  <ResizableDrawer
    color="background"
    :data-title="$t('tour.comments.drawer.title')"
    :data-intro="$t('tour.comments.drawer.intro')"
    hide-overlay
    right
    :value="open"
    :width="width"
    @input="$emit('update:open', $event)"
    @resizing="$emit('resizing', $event)"
    @width="$emit('width', $event)"
  >
    <template #header>
      <div ref="drawerSlot" class="c-header d-flex align-center">
        <v-subheader class="c-title px-3">
          {{ $t('comment.header') }}
        </v-subheader>

        <v-spacer />

        <CloseButton
          top="4px"
          right="8px"
          size="small"
          @close="$emit('update:open', false)"
        />
      </div>
      <v-alert
        v-model="noComments"
        class="ma-2 mt-0 rounded-xl"
        type="info"
      >
        {{ $t('comment.notices.first') }}
      </v-alert>
    </template>

    <template #default>
      <CommentThread
        class="ma-2"
        :comments="comments"
        rich
        show-form
        :target-id="targetId"
        @count="$emit(count)"
      />
    </template>
  </ResizableDrawer>
</template>

<script>
import { mapGetters } from 'vuex'
import CloseButton from '@/components/base/CloseButton'
import CommentThread from '@/components/comments/CommentThread'
import ResizableDrawer from '@/components/base/ResizableDrawer'

export default {
  name: 'CommentDrawer',

  components: {
    CloseButton,
    CommentThread,
    ResizableDrawer
  },

  model: {
    prop: 'open',
    event: 'update:open'
  },

  props: {
    comments: {
      type: Array,
      required: true
    },

    open: {
      type: Boolean,
      required: true
    },

    targetId: {
      type: String,
      required: true
    },

    width: {
      type: Number,
      required: false,
      default: 400
    }
  },

  data: function () {
    return {
      showInput: true
    }
  },

  computed: {
    ...mapGetters('commentStore', ['getComments']),

    noComments() {
      return this.comments.length < 1
    }
  },

  mounted: function () {},

  methods: {}
}
</script>

<style lang="css" scoped>
.c-title {
  font-size: 1rem;
  max-height: 36px;
}
</style>
